import { Component, Inject, LOCALE_ID, DOCUMENT } from '@angular/core';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Observable, Subscription } from 'rxjs';
import { SiteConfigService } from '../services/site-config.service';
import { SiteConfigInterface } from '../models/config/site-config.interface';
import { AsyncPipe } from '@angular/common';
import { IsDesktopService } from '../services/is-desktop.service';

@Component({
  selector: 'app-locale-toggle',
  imports: [NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle, AsyncPipe],
  templateUrl: './locale-toggle.component.html',
  styleUrl: './locale-toggle.component.scss',
})
export class LocaleToggleComponent {
  localeLong: { [locale: string]: string } = {
    'en-US': 'English',
    fr: 'Français',
    es: 'Español',
  };

  redirectUrl!: string;
  origin!: string;
  currentUri!: string;
  routerSub: Subscription;
  desktop$!: Observable<boolean>;
  siteConfig$!: Observable<SiteConfigInterface | null>;

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    public siteConfigService: SiteConfigService,
    private isDesktopService: IsDesktopService,
    @Inject(DOCUMENT) private document: any,
    private router: Router,
  ) {
    this.routerSub = router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: any) => {
      this.redirectUrl = this.document.location.origin + event.url;
      this.origin = this.document.location.origin;
      this.currentUri = event.url;
    });
  }

  async ngOnInit() {
    this.siteConfig$ = this.siteConfigService.updateSiteConfig;
    this.desktop$ = this.isDesktopService.isDesktop;
    this.origin = this.document.location.origin;
    this.currentUri = this.router.routerState.snapshot.url;
  }

  ngOnDestroy() {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }
}
